export default {
  required: (value) => !!value || 'Este campo es requerido',
};

// function CustomRules(required?: boolean, min?: number, max?: number, rexex?: string, messages: object = {required: 'Este campo es obligatorio'}) {
//     const rules = [];
//     if (required) { rules.push((v) => !!v || messages.required); }
//     if (min) { rules.push((v) => (v && v.length > min) || messages.min); }
//     if (max) { rules.push((v) => (v && v.length <= max) || messages.max); }
//     if (rexex) { rules.push((v) => rexex.test(v) || messages.rexex); }

//     return rules;
// }

// export function Required(text: string = 'El campo es requerido') {
//   return (v) => !!v || text;
// }

// const EmailRules = [
//     (v) => (v && v.length > 4) || 'El correo electrónico debe contener al menos 5 caracteres',
//     (v) => (v && v.length <= 80) || 'El correo electrónico debe contener un máximo de 80 caracteres',
//     (v) => /[^@]+@.+\.\w{2,4}$/.test(v) || 'El correo electrónico debe ser valido',
//     // (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) || 'El correo electrónico debe ser valido'
// ];

// const PasswordRules = [
//     (v) => !!v || 'La contraseña es obligatoria',
//     (v) => (v && v.length > 7) || 'La contraseña debe contener al menos 8 caracteres',
//     (v) => (v && v.length <= 25) || 'La contraseña debe contener un máximo de 25 caracteres',
// ];

// function PasswordConfirmRules(password: string) {
//     return [
//         (v) => !!v || 'La contraseña es obligatoria',
//         (v) => (v && v.length > 7) || 'La contraseña debe contener al menos 8 caracteres',
//         (v) => (v && v.length <= 25) || 'La contraseña debe contener un máximo de 25 caracteres',
//         (v) => (v === password) || 'La contraseña deben coincidir',
//     ];
// }

// const IdentificationTypeRules = [
//     (v) => !!v || 'El tipo de identificación es obligatorio',
// ];

// const IdentificationRules = [
//     (v) => !!v || 'La Cédula de identidad es obligatoria',
//     (v) => (v && v.length > 3) || 'La Cédula de identidad debe contener al menos 4 caracteres',
//     (v) => (v && v.length <= 22) || 'La Cédula de identidad debe contener menos de 22 caracteres',
// ];

// const FullNameRules = [
//     (v) => !!v || 'El Nombre es obligatorio',
//     (v) => (v && v.length > 3) || 'El Nombre debe contener al menos 4 caracteres',
//     (v) => (v && v.length <= 60) || 'El Nombre debe contener menos de 60 caracteres',
//     (v) => /^[a-zA-ZñÑáéíóúÁÉÍÓÚ]*\s+[a-zA-ZñÑáéíóúÁÉÍÓÚ]/.test(v) || 'Debes introducir al menos un apellido',
// ];

// const PhoneRules = [
//     (v) => !!v || 'El numero de teléfono es obligatorio',
//     (v) => /^[0-9-+]*$/.test(v) || 'El numero de teléfono debe contener numeros, guiones o signo mas(+)',
// ];

// const AliasRules = [
//     (v) => !!v || 'El Alias es obligatorio',
//     (v) => (v && v.length <= 50) || 'El Alias debe tener maximo 50 caracteres',
// ];

// const PolicyNumRules = [
//     (v) => !!v || 'El numero de póliza es obligatorio',
//     (v) => (v && v.length > 3) || 'El numero de póliza debe contener al menos 3 caracteres',
//     (v) => (v && v.length <= 50) || 'El numero de póliza debe contener un máximo de 50 caracteres',
//     (v) => /^[a-zA-Z0-9-]*$/.test(v) || 'El numero de póliza debe contener letras, numeros o guiones',
// ];

// const BankAccountNumRules = [
//     (v) => !!v || 'El numero de cuenta es obligatorio',
//     (v) => v.length === 16 || 'El numero de cuenta debe tener 20 caracteres',
// ];

// export {
//     CustomRules,
//     RequiredRules,
//     EmailRules,
//     PasswordRules,
//     PasswordConfirmRules,
//     IdentificationTypeRules,
//     IdentificationRules,
//     FullNameRules,
//     PhoneRules,
//     AliasRules,
//     PolicyNumRules,
//     BankAccountNumRules,
// };
